import { lazyRetry } from '@cast/utils';

import { BASE_PATHS } from '@oneclick/constants/navigation';

import type { OneClickNavItem } from '@oneclick/routing';

const SsoConnectionsPage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/SsoConnectionsPage'
  ).then((m) => ({ default: m.SsoConnectionsPage }))
);
const SetupSsoConnectionPage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/SetupSsoConnectionPage'
  ).then((m) => ({ default: m.SetupSsoConnectionPage }))
);
const EditSsoConnectionPage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/EditSsoConnectionPage'
  ).then((m) => ({ default: m.EditSsoConnectionPage }))
);
const SsoGroupSyncPage = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/SsoGroupSyncPage').then(
    (m) => ({ default: m.SsoGroupSyncPage })
  )
);
const SamlGroupSyncPage = lazyRetry(() =>
  import('@cast/split-me/pages/organization/management/SamlGroupSyncPage').then(
    (m) => ({ default: m.SamlGroupSyncPage })
  )
);

/** Relative routes under `/organization/management/sso-connections/*`. */
export const SSO_ROUTE_CONFIG: OneClickNavItem[] = [
  {
    id: 'ssoConnections',
    title: 'Single sign-on',
    route: '',
    matchRoute: BASE_PATHS.ssoConnections,
    page: SsoConnectionsPage,
    breadcrumbs: ['Single sign-on'],
    rules: [['view', 'OrganizationSsoConnections']],
    end: true,
  },
  {
    title: 'Setup SSO',
    route: 'setup',
    page: SetupSsoConnectionPage,
    breadcrumbs: ['Single sign-on'],
    rules: [['view', 'OrganizationSsoConnections']],
    routeOnly: true,
  },
  {
    title: 'SSO group sync',
    route: 'group-sync',
    page: SsoGroupSyncPage,
    breadcrumbs: ['Single sign-on'],
    rules: [['view', 'OrganizationSsoConnections']],
    routeOnly: true,
  },
  {
    title: 'SAML group sync',
    route: ':connectionId/saml-group-sync',
    page: SamlGroupSyncPage,
    breadcrumbs: ['Single sign-on'],
    rules: [
      ['view', 'OrganizationSsoConnections'],
      ['view', 'FeatureSsoSaml'],
    ],
    routeOnly: true,
  },
  {
    title: 'Edit SSO',
    route: ':connectionId',
    page: EditSsoConnectionPage,
    breadcrumbs: ['Single sign-on'],
    rules: [['view', 'OrganizationSsoConnections']],
    routeOnly: true,
  },
];
